import { http, HttpResponse } from "msw";
import { BASE_URL } from "../constants";
import { loadMock } from "../utils";

const SESSION_DURATION_MS = 15 * 60 * 1000;

const freshSession = () => {
  const now = Date.now();
  return { startedAt: new Date(now).toISOString(), expiresAt: new Date(now + SESSION_DURATION_MS).toISOString() };
};

const flightHandlers = [
  http.post(`${BASE_URL}/Travel/airports/search`, async () => HttpResponse.json(await loadMock("Flights/airports"))),
  http.post(`${BASE_URL}/travel/flights/search`, async () => {
    const response = await loadMock("Flights/search");
    return HttpResponse.json({ ...response, result: { ...response.result, session: freshSession() } });
  }),
  http.post(`${BASE_URL}/travel/flights/details`, async () => HttpResponse.json(await loadMock("Flights/details"))),
];

export { flightHandlers };
